import React from 'react';

const PreviewVideo = ({src, isMobile}) => {
  if (src) {
    if (isMobile) {
      return (
        <div className="mobileExerciseDemo">
          <h2 className="text-center">Preview: </h2>
          <video autoPlay loop muted src={src}></video>
          <img className="previewFooter" src="/preview_footer.png" alt="preview footer"/>
        </div>
      )
    }else{
      return (
        <div>
          <h2 className="text-center">Preview: </h2>
          <div className="smartphone">
            <div className="content">
              <video autoPlay loop muted src={src}></video>
              <img className="previewFooter" src="/preview_footer.png" alt="preview footer"/>
            </div>
          </div>
        </div>

      )
    }
  }
  return null;

}

export default PreviewVideo;



// WEBPACK FOOTER //
// ./src/components/upload/PreviewVideo.js